import { Image as BaseImage, type ImageProps } from "@unpic/react/base";
import type { Except } from "type-fest";
import {
  type IPXOperations,
  type IPXOptions,
  transform,
} from "unpic/providers/ipx";

export function Image(
  props: Except<ImageProps<IPXOperations, IPXOptions>, "transformer">,
) {
  return <BaseImage {...props} transformer={transform} />;
}
